export class StoryTranslationMetaInfo {
    title: string;
    description: string;
}

export class StoryTranslationMarkdownBlock {
    markdown: string;
}

export class StoryTranslationQuizOptionModel {
    label: string | StoryTranslationMetaInfo;
}

export class StoryTranslationQuizQuestionModel {
    nextLabel: string;
    explanation: StoryTranslationMarkdownBlock[];
    questionPrompt: StoryTranslationMarkdownBlock[];
    data?: {
        options: StoryTranslationQuizOptionModel[];
    };
}

export class StoryTranslationChapterModel extends StoryTranslationMetaInfo  {
    annotations?: StoryTranslationMetaInfo[];
    hotspots?: StoryTranslationMetaInfo[];
    quizQuestions?: StoryTranslationQuizQuestionModel[];
}

export class StoryTranslationModel {

    displayName: string;
    description: string;
    iso_639_1: string;
    language: string;

    chapters?: StoryTranslationChapterModel[];

    hotspots?: StoryTranslationMetaInfo[];

    objects?: {
        [key: string]: string; 
    };
}
